export default __webpack_public_path__ + "static/media/OSM-slider4.cdcdb85c.jpg";